module.exports = __webpack_public_path__ + "static/img/sylogo.3d7d1f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sylogo.png
// module id = Bn8+
// module chunks = 1